export default "__VITE_PUBLIC_ASSET__e45be561__"